import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import "@arco-design/web-react/es/Grid/style";
import _Grid from "@arco-design/web-react/es/Grid";
import { useScroll } from 'ahooks';
import React, { useState } from 'react';
const {
  Row,
  Col
} = _Grid;
export function LongText({
  value,
  placeholder,
  disabled,
  maxLength,
  options,
  isSelectTemplate,
  rows = 4,
  onChange
}) {
  const [open, setOpen] = useState(false);
  const [checkValues, setCheckValues] = useState([]);
  useScroll(document.querySelector('.arco-modal-body'), () => {
    if (open) {
      setOpen(false);
    }
    return true;
  });
  function onCheckboxChange(checkedValues) {
    // 对比后删除取消的字符串
    let nextValue = value ?? '';
    checkValues.forEach(item => {
      if (!checkedValues.includes(item) && nextValue) {
        nextValue = nextValue?.replaceAll(`。${item}`, '')?.replaceAll(`${item}。`, '')?.replaceAll(item, '');
      }
    });
    const checked = checkedValues;
    const vals = checked.filter(key => !nextValue?.includes?.(key));
    const cVal = vals.join(',') || '';
    let val = '';
    if (nextValue) {
      val = [nextValue, cVal].filter(item => item).join('。');
    } else {
      val = cVal;
    }
    setCheckValues(checked);
    onChange?.(val);
  }
  function onTextChange(val) {
    const text = val || '';

    // 文字改变后，在模版中有，就需要选择
    options?.forEach(item => {
      if (!checkValues.includes(item.label) && text.includes(item.label)) {
        checkValues.push(item.label);
      }
    });

    // 文字改变后，在模版中没有，就需要不选择
    const vals = checkValues.filter(key => text.includes(key));
    setCheckValues(vals);
    onChange?.(text);
  }
  function title() {
    return /*#__PURE__*/React.createElement(_Checkbox.Group, {
      value: checkValues,
      style: {
        width: '100%'
      },
      onChange: onCheckboxChange
    }, /*#__PURE__*/React.createElement(Row, null, options?.map?.((item, index) => /*#__PURE__*/React.createElement(Col, {
      key: index,
      span: 24
    }, /*#__PURE__*/React.createElement(_Checkbox, {
      value: item.label
    }, item.label)))));
  }
  if (isSelectTemplate) {
    return /*#__PURE__*/React.createElement(_Tooltip, {
      trigger: "hover",
      position: "bottom",
      popupVisible: open,
      content: title,
      onVisibleChange: visible => setOpen(visible)
    }, /*#__PURE__*/React.createElement(_Input.TextArea, {
      value: value,
      placeholder: placeholder,
      disabled: disabled,
      showWordLimit: Boolean(maxLength),
      maxLength: maxLength,
      autoSize: {
        minRows: rows,
        maxRows: rows * 2
      },
      onChange: onTextChange
    }));
  }
  return /*#__PURE__*/React.createElement(_Input.TextArea, {
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    showWordLimit: Boolean(maxLength),
    maxLength: maxLength,
    autoSize: {
      minRows: rows,
      maxRows: rows * 2
    },
    onChange: onTextChange
  });
}
export default LongText;